import BaseRequest from '../../components/base/base-request';

const sendConfirmationLinkUrl = '/emailConfirmation/resend';
interface IRequestConfirmationLink {
    success?: boolean;
}

class EmailConfirmationRequests extends BaseRequest {
    public async sendConfirmationLink(): Promise<IRequestConfirmationLink> {
        return this.rawRequest<IRequestConfirmationLink>(sendConfirmationLinkUrl, null, { type: 'POST' });
    }
}

export const emailConfirmationRequests = new EmailConfirmationRequests();
